import FactureAvoirUpdateController from './facture.avoir.update.controller';

export default {
    bindings: {
        modalInstance: '=',
        idClient: '=',
        idClientDivers: '=',
        idSite: '=',
        idSociete: '=',
        tickets: '=',
        date: '=',
        isDelete: '='
    },
    template: require('./facture.avoir.update.html'),
    controller: FactureAvoirUpdateController
};